var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flyer-thumb-list"},_vm._l((_vm.thumbs),function(flyer){return _c('flyer-thumb-button',{key:flyer.title,attrs:{"flyer-data":flyer}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }